import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";
import PccSearch from "./PccSearch";
import { useScrollToHashOnMount } from "../../hooks/useScrollToHashOnMount";

const TOPICS = [
  { slug: "pricing-income", label: "Pricing & Income" },
  { slug: "tax-admin", label: "Tax & Admin" },
  { slug: "payment-protection", label: "Payment Protection" },
  { slug: "contracts-agreements", label: "Contracts & Agreements" },
  { slug: "working-independently", label: "Working Independently" },
  { slug: "shift-kit", label: "Shift Kit" },
  { slug: "safety-escalation", label: "Safety & Escalation" },
  { slug: "training-cpd", label: "Training & CPD" },
];

// Shared shell for every Pro Carer Circle category page: breadcrumb back to
// the dashboard, a Start Here link, the PCC search, and a "browse other
// topics" nav — so members are never stuck using the browser Back button.
export default function CategoryPageShell({ slug, eyebrow, title, description, children, testId }) {
  useScrollToHashOnMount();
  return (
    <div className="min-h-screen bg-surface-carer" data-testid={testId}>
      <div className="container-jcc py-8 md:py-14 max-w-5xl">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm">
          <Link
            to="/workspace/pro-carer-circle"
            className="inline-flex items-center gap-2 text-ink-muted hover:text-ink"
            data-testid="pcc-category-back"
          >
            <ArrowLeft className="w-4 h-4" /> Pro Carer Office
          </Link>
          <span className="text-slate-300">/</span>
          <Link
            to="/workspace/pro-carer-circle/start-here"
            className="text-ink-muted hover:text-ink"
            data-testid="pcc-category-start-here"
          >
            Start Here guide
          </Link>
        </div>

        <header className="mt-6 max-w-2xl">
          <div className="overline text-purple">{eyebrow}</div>
          <h1 className="mt-2 font-display font-bold text-3xl md:text-4xl">{title}</h1>
          <p className="mt-3 text-ink-muted leading-relaxed">{description}</p>
        </header>

        <div className="mt-6 max-w-xl">
          <PccSearch compact />
        </div>

        <div className="mt-10 space-y-10 min-w-0">{children}</div>

        <div className="mt-14 rounded-3xl border border-slate-200 bg-white p-6 md:p-8">
          <div className="overline text-teal mb-3 flex items-center gap-2">
            <Compass className="w-4 h-4" strokeWidth={2} /> Browse other topics
          </div>
          <div className="flex flex-wrap gap-2">
            {TOPICS.map((t) => (
              <Link
                key={t.slug}
                to={`/workspace/pro-carer-circle/${t.slug}`}
                data-testid={`pcc-topic-nav-${t.slug}`}
                className={`pill text-sm transition-colors ${
                  t.slug === slug ? "bg-purple text-white" : "bg-slate-100 text-ink hover:bg-slate-200"
                }`}
              >
                {t.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
